import { InjectionToken } from '@angular/core';
export var CONFIGURE_PROJECT_LOADING_HANDLERS = new InjectionToken('CONFIGURE_PROJECT_LOADING_HANDLERS');
